import $ from "jquery";

import URI from "urijs/src/URI";
import "urijs/src/jquery.URI";

var tx_solr_facetLabels = {
    showFewer: 'less',
    showMore: 'more'
};
// ref: https://github.com/medialize/URI.js/
function SearchController() {
    var _this = this;

    _this.ajaxType = 7383;

    _this.lastRequest = URI(window.location);

    _this.lastRequest = null;

    this.init = function() {
        $("a.solr-ajaxified").click( function(event){
            event.preventDefault();
            _this.handleClickOnAjaxifiedUri(false, this);
        });
        var chosen = $('.tx_solr .chosen-select, .tx_solr .chosen-select-multiple');
        chosen.on('change', function (evt, params) {
            if (params == 'undefined'){
                console.log($(this),  evt,  params);
            }
            _this.handleClickOnAjaxifiedUri(params.selected ? params.selected : params.deselected, this)
        });
        var removedFacet = $('.remove-facet-option,.facet-checkbox.solr-ajaxified');
        removedFacet.on('click', function (evt) {
            _this.handleClickOnAjaxifiedUri($(this).val(), this)
        });
        $('.tx-solr-facet-hidden').hide();
        $('a.tx-solr-facet-show-all').click(function() {
            if ($(this).parent().siblings('.tx-solr-facet-hidden:visible').length == 0) {
                $(this).parent().siblings('.tx-solr-facet-hidden').show();
                $(this).text(tx_solr_facetLabels.showFewer);
            } else {
                $(this).parent().siblings('.tx-solr-facet-hidden').hide();
                $(this).text(tx_solr_facetLabels.showMore);
            }

            return false;
        });
    };

    this.handleClickOnAjaxifiedUri = function(URL, element) {
        if (_this.lastRequest){ _this.lastRequest.abort();}

        var clickedLink = element ? $(element) : $(this);

        var overlay = $("<div class=\"tx-solr-overlay\"></div>");
        var loader = $("<div class='tx-solr-loader'><i class='lnr lnr-sync lnr-spin'/></div>");

        var solrContainer = clickedLink.closest(".tx_solr");
        var solrParent = solrContainer.parent();

        var uri = URL ? URI(URL) : clickedLink.uri();
        clickedLink.closest(".tx_solr > .row").css('position','relative');
        clickedLink.closest(".tx_solr > .row").append(overlay);
        clickedLink.closest(".tx_solr > .row").append(loader);
        // solrParent.append(loader);
        uri.addQuery("type", _this.ajaxType);

        _this.lastRequest = uri;

        _this.lastRequest = $.get(
            uri.href()
        );
        _this.lastRequest.done(function(data) {
                solrContainer = solrContainer.replaceWith($(data).find('.tx_solr'));
            }
        );
        _this.lastRequest.always(function () {
            _this.scrollToTopOfElement(solrParent, 50);
            history.pushState(undefined, '', uri.removeSearch('type').href());
            overlay.fadeOut().remove();
            loader.fadeOut().remove();
            $("body").trigger("tx_solr_updated");
        });
        return false;
    };

    this.scrollToTopOfElement = function(element, deltaTop) {
        $('html, body').animate({
            scrollTop: (element.offset().top - deltaTop) + 'px'
        }, 'slow');
    };

    this.setAjaxType = function(ajaxType) {
        _this.ajaxType = ajaxType;
    };
}

$(document).ready(function() {
    var solrSearchController = new SearchController();
    solrSearchController.init();

    if(typeof solrSearchAjaxType !== "undefined") {
        solrSearchController.setAjaxType(solrSearchAjaxType);
    }
    $("body").on("tx_solr_updated", function() {
        solrSearchController.init();
    });
});
